import { helpers } from 'vuelidate/lib/validators'

const fonctionTest = function(value,param) {
  if(!value) {
    return true;
  }
  if (!value.size) {
    return false;
  }
  // 1048576 pour Megaoctet
  // 1000000 pour Megabite
  if (value.size <= (param * 1048576)) {
    return true;
  }
  return false;
}

const maxsizefile = (param) =>
  helpers.withParams(
    { type: 'maxsizefile', value: param },
    (value) => fonctionTest(value,param)
  )

export { maxsizefile };